import dayjs from "dayjs";
import Litepicker from "litepicker";

(function (cash) {
    "use strict";
    window.datepickers = [];
    // Litepicker
    window.datepicker_init = function(){
        if( window.datepickers.length > 0 ){
            cash.each( window.datepickers, function(index,datepicker){
                datepicker.destroy();
            });
            window.datepickers = [];
        }
        cash(".datepicker").each(function () {
            let options = {
                autoApply: false,
                singleMode: false,
                numberOfColumns: 2,
                numberOfMonths: 2,
                showWeekNumbers: true,
                format: "D MMM, YYYY",
                dropdowns: {
                    minYear: 1990,
                    maxYear: null,
                    months: true,
                    years: true,
                },
            };

            if (cash(this).data("single-mode")) {
                options.singleMode = true;
                options.numberOfColumns = 1;
                options.numberOfMonths = 1;
            }

            if (cash(this).data("format")) {
                options.format = cash(this).data("format");
            }

            if (!cash(this).val()) {
                let date = dayjs().format(options.format);
                date += !options.singleMode
                    ? " - " + dayjs().add(1, "month").format(options.format)
                    : "";
                cash(this).val(date);
            }

            // new Litepicker({
            //     element: this,
            //     ...options,
            // });

            window.datepickers.push(new Litepicker({
                element: this,
                ...options,
            }));
        });
    }

    window.datepicker_init();


    window.getDatePickerByID = function(id){
        let found_date = null;
        cash(window.datepickers).each( function(index,date_obj){
            if(date_obj.options.element.id == id){
                found_date = date_obj;
                return false;
            }
        });
        return found_date;

    };

})(cash);
